export default "__VITE_ASSET__3fce24c4__"